import { useMemo, type ReactNode } from 'react';

import cn from 'classnames';

import { Text } from 'ui/atoms/Text/Text';
import { Icon } from 'ui/atoms/Icon/Icon';

import styles from './DetailsBlock.module.scss';

const baseClass = 'details-block';

type Props = {
  title?: string;
  description?: string;
  iconType?: string;
  kicker?: ReactNode;
  theme?: 'light' | 'dark';
  actions?: ReactNode;
  className?: string;
  rightSide?: ReactNode;
};

export const DetailsBlock = ({
  title,
  description,
  iconType,
  theme = 'light',
  kicker,
  actions,
  className,
  rightSide,
}: Props) => {
  const splitDescription = useMemo(() => (description && description.split('\\n')) || [], [description]);

  return (
    <section
      className={cn(
        styles[`${baseClass}-wrapper`],
        styles[`${baseClass}-${theme}`],
        rightSide ? styles[`${baseClass}--has-right-side`] : undefined,
        className,
      )}
    >
      <div className={styles[`${baseClass}-container`]}>
        {iconType && <Icon type={iconType} className={styles[`${baseClass}-icon`]} />}

        {kicker && <div className={styles[`${baseClass}-kicker`]}>{kicker}</div>}

        {title && (
          <Text size="lg" tag="h1">
            {title}
          </Text>
        )}

        {splitDescription.length > 0 && (
          <Text size="sm" tag="p" className={styles[`${baseClass}-desc`]}>
            {splitDescription.map((i, idx) => (
              <>
                {i}

                {splitDescription.length !== idx + 1 && <span className="block" />}
              </>
            ))}
          </Text>
        )}

        {actions && <div className={styles[`${baseClass}-actions`]}>{actions}</div>}
      </div>

      {rightSide && <div className={styles[`${baseClass}-rs-container`]}>{rightSide}</div>}
    </section>
  );
};
